module.exports = __webpack_public_path__ + "img/CM.65f87b6f.jpg";